import React from 'react';
import styles from './NeuralSpinner.module.css';

const NeuralSpinner = ({ size = 'medium', message = 'Загрузка...' }) => {
  const sizeClass = styles[size] || styles.medium;

  return (
    <div className={styles.spinnerContainer}>
      <div className={`${styles.neuralSpinner} ${sizeClass}`}>
        {/* Центральный узел */}
        <div className={styles.centralNode}>
          <div className={styles.nodePulse}></div>
        </div>

        {/* Орбитальные узлы (нейроны) */}
        <div className={`${styles.neuron} ${styles.neuron1}`}>
          <div className={styles.neuronCore}></div>
          <div className={styles.neuronGlow}></div>
        </div>
        <div className={`${styles.neuron} ${styles.neuron2}`}>
          <div className={styles.neuronCore}></div>
          <div className={styles.neuronGlow}></div>
        </div>
        <div className={`${styles.neuron} ${styles.neuron3}`}>
          <div className={styles.neuronCore}></div>
          <div className={styles.neuronGlow}></div>
        </div>
        <div className={`${styles.neuron} ${styles.neuron4}`}>
          <div className={styles.neuronCore}></div>
          <div className={styles.neuronGlow}></div>
        </div>
        <div className={`${styles.neuron} ${styles.neuron5}`}>
          <div className={styles.neuronCore}></div>
          <div className={styles.neuronGlow}></div>
        </div>
        <div className={`${styles.neuron} ${styles.neuron6}`}>
          <div className={styles.neuronCore}></div>
          <div className={styles.neuronGlow}></div>
        </div>

        {/* Соединения (синапсы) */}
        <svg className={styles.connections} viewBox="0 0 200 200">
          <defs>
            <linearGradient id="lineGradient1" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#0f766e" stopOpacity="0.1" />
              <stop offset="50%" stopColor="#14b8a6" stopOpacity="0.8" />
              <stop offset="100%" stopColor="#0f766e" stopOpacity="0.1" />
            </linearGradient>
            <linearGradient id="lineGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0d9488" stopOpacity="0.1" />
              <stop offset="50%" stopColor="#2dd4bf" stopOpacity="0.7" />
              <stop offset="100%" stopColor="#0d9488" stopOpacity="0.1" />
            </linearGradient>
          </defs>

          {/* Линии соединений */}
          <line className={styles.connection} x1="100" y1="100" x2="150" y2="50" stroke="url(#lineGradient1)" />
          <line className={styles.connection} x1="100" y1="100" x2="150" y2="150" stroke="url(#lineGradient1)" />
          <line className={styles.connection} x1="100" y1="100" x2="50" y2="150" stroke="url(#lineGradient2)" />
          <line className={styles.connection} x1="100" y1="100" x2="50" y2="50" stroke="url(#lineGradient2)" />
          <line className={styles.connection} x1="100" y1="100" x2="100" y2="30" stroke="url(#lineGradient1)" />
          <line className={styles.connection} x1="100" y1="100" x2="170" y2="100" stroke="url(#lineGradient2)" />

          {/* Пульсирующие точки на линиях */}
          <circle className={styles.dataPulse} r="2" fill="#14b8a6">
            <animateMotion dur="2s" repeatCount="indefinite">
              <mpath href="#path1" />
            </animateMotion>
          </circle>

          <path id="path1" d="M 100 100 L 150 50" fill="none" stroke="none" />
        </svg>

        {/* Частицы данных */}
        <div className={styles.dataParticles}>
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className={styles.particle}
              style={{
                '--delay': `${i * 0.2}s`,
                '--angle': `${(i * 30)}deg`
              }}
            ></div>
          ))}
        </div>

        {/* Энергетическое кольцо */}
        <div className={styles.energyRing}></div>
        <div className={styles.energyRing2}></div>
      </div>

      {message && <div className={styles.loadingMessage}>{message}</div>}
    </div>
  );
};

export default NeuralSpinner;
